import * as devisConf from '@/configuration/devisConf';

export default function miseAJourSousTotal(ligneCommande, i18n) {
  ligneCommande.libelle = i18n.t('ajoutDevis.informations.subTotalHt');
  ligneCommande.type = devisConf.SOUS_TOTAL;
}
